import Dialog from "@stimulus-components/dialog";

export default class extends Dialog {
}
